import React, { useRef } from "react";
import styled from "styled-components/macro";
import { UnitMoveButton } from "./UnitMoveButton";
import { UnitScaleButton } from "./UnitScaleButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import addLogo from "../../images/unit/addLogo.png";
import dimensions from "../../images/unit/dimentions.svg";

const UnitTool = ({
  onMoveClick,
  onScaleClick,
  onBackgroundChange,
  onLogoChange,
  onDimensionsClick,
  onColorClick,
}) => {
  const inputRef = useRef();

  return (
    <Wrapper>
      <Section>
        <UnitMoveButton onClick={onMoveClick} />
        <div style={{ marginTop: "20px" }}>
          <UnitScaleButton onClick={onScaleClick} />
        </div>
      </Section>
      <div
        style={{ height: "1px", width: "100%", backgroundColor: "#dcdcdc" }}
      />

      <Section>
        <Title>{"Dimensions"}</Title>
        <div
          style={{ width: "35px", height: "35px", cursor: "pointer" }}
          onClick={onDimensionsClick}
        >
          <img
            width={40}
            height={40}
            src={dimensions}
            style={{ objectFit: "contain", zIndex: 1 }}
            alt={"dimensions"}
          />
        </div>
      </Section>
      <div
        style={{ height: "1px", width: "100%", backgroundColor: "#dcdcdc" }}
      />

      <Section>
        <Title>{"Your Logo"}</Title>
        <AddLogoWrapper>
          <FontAwesomeIcon size={"lg"} color={"#707070"} icon={faPlus} />
          <UploadFileInput
            ref={inputRef}
            onChange={(event) => {
              onLogoChange(event.target.files[0]);
              // console.log(event.target.files[0])
              // singleFileUploadHandler(file, "operation_upload_printer_files", (url)=> console.log(url))
            }}
            type="file"
          />
        </AddLogoWrapper>
      </Section>
      <div
        style={{ height: "1px", width: "100%", backgroundColor: "#dcdcdc" }}
      />

      <Section>
        <Title>{"Upload Image"}</Title>
        <div
          style={{
            width: "35px",
            height: "35px",
            display: "flex",
            position: "relative",
          }}
        >
          <img
            width={40}
            height={40}
            src={addLogo}
            style={{ objectFit: "contain", zIndex: 1 }}
            alt={"addLogo"}
          />
          <UploadFileInput
            ref={inputRef}
            onChange={(event) => {
              onBackgroundChange(event.target.files[0]);
            }}
            type="file"
          />
        </div>
      </Section>

      <div
        style={{ height: "1px", width: "100%", backgroundColor: "#dcdcdc" }}
      />
      <Section>
        <Title>{"Color"}</Title>
        <Color
          onClick={() => onColorClick("#4a4a4a")}
          style={{ marginBottom: "10px" }}
          color={"#707070"}
          borderColor={"#707070"}
        />
        <Color
          onClick={() => onColorClick("#f9f3e9")}
          style={{ marginBottom: "10px" }}
          color={"#FFFFFF"}
          borderColor={"#707070"}
        />
        <Color
          onClick={() => onColorClick("#b6af9c")}
          style={{ marginBottom: "10px" }}
          color={"#b6af9c"}
          borderColor={"#b6af9c"}
        />
      </Section>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  color: #707070;
  position: relative;
  flex-direction: column;
  border-radius: 50px;
  box-shadow: 2px 2px 5px #bababa;
  background-color: white;
`;

const Color = styled.div`
  display: flex;
  width: 50px;
  cursor: pointer;
  height: 50px;
  position: relative;
  border-radius: 50%;
  box-shadow: 2px 2px 5px #bababa;
  background-color: ${({ color }) => color};
  border: 4px solid ${({ borderColor }) => borderColor};
`;

const AddLogoWrapper = styled.div`
  cursor: pointer;
  width: 35px;
  height: 35px;
  border-radius: 11px;
  border: 2px solid #707070;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
`;

const Section = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  padding: 13px 10px;
  align-items: center;
`;

const Title = styled.p`
  color: #707070;
  font-size: 14px;
  white-space: pre-wrap;
  margin-bottom: 8px;
  text-align: center;
  font-family: Manrope, serif;
`;

const UploadFileInput = styled.input`
  cursor: pointer;
  font-size: 1px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  opacity: 0;
  z-index: 9999;
`;
export { UnitTool };
